<div class="card">
  <app-header
    titulo="Cadastro de Material"
    descricao="Digite as informações"
  ></app-header>

  <div class="formgrid grid p-fluid">
    <div class="field col-4">
      <label for="empresaErp">Empresa: </label>
      <p-dropdown
        appendTo="body"
        [options]="empresas"
        [filter]="true"
        [(ngModel)]="empresaSelecionada"
        placeholder="Código Empresa"
        emptyMessage="Nenhuma código"
        (onChange)="buscaDepositos()"
      >
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="empresaSelecionada">
            {{ empresaSelecionada.instancia }}: {{ empresaSelecionada.empresaErp}} | UF:{{ empresaSelecionada.cdUf }}
        </div>
    </ng-template>
      <ng-template let-empresa pTemplate="item">
        {{ empresa.instancia }}: {{ empresa.empresaErp}} | UF:{{ empresa.cdUf }}
    </ng-template>
      </p-dropdown>
    </div>
    <div class="field col-4">
      <label for="empresaErp">Depósito: </label>
      <p-dropdown
        appendTo="body"
        [options]="depositos"
        [filter]="true"
        [(ngModel)]="depositoSelecionado"
        placeholder="Código Depósito ERP"
        emptyMessage="Nenhuma código ou selecione uma empresa"
      >
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="depositoSelecionado">
            {{ depositoSelecionado.cdDepositoErp }}
        </div>
    </ng-template>
      <ng-template let-deposito pTemplate="item">
        {{ deposito.cdDepositoErp	 }}
    </ng-template>
      </p-dropdown>
    </div>
    <div class="field col-4">
      <label for="ordem">Material: </label>
      <input
        type="text"
        id="ordem"
        maxlength="20"
        pInputText
        [(ngModel)]="materialDeposito.cdMaterialPims"
        required
      />
    </div>
    <div class="field col-2 pt-4">
      <button
        pButton
        icon="pi pi-save"
        class="p-button-success"
        [label]="materialDeposito.id ? 'Atualizar' : 'Salvar'"
        (click)="salvar()"
      ></button>
    </div>
    <div class="field col-2 pt-4">
      <button
        pButton
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-text"
        (click)="fecharDialog()"
      ></button>
    </div>
  </div>
</div>
